<template>
<div>
	<vue-slider
		v-model="value"
		:fixed="fixed"
		:min="min"
		:max="max"
		:height="10"
		:interval="interval"
		:tooltip-formatter="format_time"
		:tooltip="'always'"
		:tooltip-placement="['top', 'bottom']"
		:dotStyle="{'backgroundColor': this.dotColor }"
		:processStyle="{'backgroundColor': this.backgroundColor }"
	/>
</div>
</template>

<script>
import vueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
	name: "slider",
	components: {
		vueSlider,
	},
	data: function() {
		return {
			interval: 0.1,
			value: 0,
			min: 0,
			max: 0,
			height: 60,
			dotWidth: 10,
			dotHeight: 60,
			fixed: false,
			dotColor: "#FFF",
			backgroundColor: "#CCC",
		};
	},
	methods: {
		getValue() {
			return this.value;
		},
		setValue(value) {
			if(Object.prototype.toString.call(value) === "[object Array]") {
				this.value = [Math.min(value[0], this.max), Math.min(value[1], this.max)];
			}
			else {
				this.value = Math.min(value, this.max);
			}
		},
		getMax() {
			return this.max;
		},
		setMax(maxValue) {
			maxValue = parseFloat(maxValue);
			this.max = Number(maxValue.toFixed(1));
		},
		getFixed() {
			return this.fixed;
		},
		setFixed(value) {
			this.fixed = value;
		},
		setBackgroundColor(value) {
			this.backgroundColor = value;
		},
		setDotColor(value) {
			this.dotColor = value;
		},
		setSliderStyle(value) {
			this.sliderStyle = value;
		},
		format_time(value) {
			let min = "";
			let sec = (value % 60).toFixed(1);
			const minutes = Math.floor(value / 60);
			if (minutes > 0) {
				min = minutes + "m ";
			}

			return min + sec + "s";
		},
	},
};
</script>

<style scoped>
div {
	margin-bottom:15px;
}
</style>
